// Minimal inline SVG icons (Lucide-style, stroke = currentColor). Caller sets
// size via className (e.g. "h-6 w-6"). No icon dependency for a stub site.
type P = { className?: string };

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export const ActivityIcon = ({ className }: P): JSX.Element => (
  <svg {...base} className={className}>
    <path d="M3 12h4l3 8 4-16 3 8h4" />
  </svg>
);

export const RouteIcon = ({ className }: P): JSX.Element => (
  <svg {...base} className={className}>
    <circle cx="6" cy="19" r="2.5" />
    <circle cx="18" cy="5" r="2.5" />
    <path d="M8.5 19H14a4 4 0 0 0 0-8H10a4 4 0 0 1 0-8h5.5" />
  </svg>
);

export const MapPinIcon = ({ className }: P): JSX.Element => (
  <svg {...base} className={className}>
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

export const BellIcon = ({ className }: P): JSX.Element => (
  <svg {...base} className={className}>
    <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.7 21a2 2 0 0 1-3.4 0" />
  </svg>
);

export const SlidersIcon = ({ className }: P): JSX.Element => (
  <svg {...base} className={className}>
    <path d="M4 6h10M18 6h2M4 12h2M10 12h10M4 18h12M20 18h0" />
    <circle cx="16" cy="6" r="2" />
    <circle cx="8" cy="12" r="2" />
    <circle cx="18" cy="18" r="2" />
  </svg>
);

export const PlugIcon = ({ className }: P): JSX.Element => (
  <svg {...base} className={className}>
    <path d="M9 2v6M15 2v6" />
    <path d="M6 8h12v3a6 6 0 0 1-12 0V8Z" />
    <path d="M12 17v5" />
  </svg>
);

export const CarIcon = ({ className }: P): JSX.Element => (
  <svg {...base} className={className}>
    <path d="M5 13l1.5-4.5A2 2 0 0 1 8.4 7h7.2a2 2 0 0 1 1.9 1.5L19 13" />
    <path d="M3 13h18v4a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H6v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4Z" />
    <path d="M7 16h.01M17 16h.01" />
  </svg>
);

export const FingerprintIcon = ({ className }: P): JSX.Element => (
  <svg {...base} className={className}>
    <path d="M12 10a2 2 0 0 0-2 2c0 3 .5 5-1 7" />
    <path d="M12 6a6 6 0 0 0-6 6c0 2-.5 4-1 5" />
    <path d="M12 6a6 6 0 0 1 6 6c0 2 0 4 .5 5" />
    <path d="M12 10a2 2 0 0 1 2 2c0 4 .5 6 1 7" />
  </svg>
);

export const ShieldIcon = ({ className }: P): JSX.Element => (
  <svg {...base} className={className}>
    <path d="M12 3l7 3v5c0 5-3 8-7 10-4-2-7-5-7-10V6l7-3Z" />
    <path d="M9.5 12l1.8 1.8L15 10" />
  </svg>
);

export const LockIcon = ({ className }: P): JSX.Element => (
  <svg {...base} className={className}>
    <rect x="5" y="11" width="14" height="9" rx="2" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </svg>
);

export const CloudIcon = ({ className }: P): JSX.Element => (
  <svg {...base} className={className}>
    <path d="M7 18a4 4 0 0 1-.5-7.97A6 6 0 0 1 18 9.5a3.5 3.5 0 0 1-.5 8.5H7Z" />
  </svg>
);

export const FlagIcon = ({ className }: P): JSX.Element => (
  <svg {...base} className={className}>
    <path d="M5 21V4" />
    <path d="M5 4h11l-1.5 3L16 10H5" />
  </svg>
);

export const TagIcon = ({ className }: P): JSX.Element => (
  <svg {...base} className={className}>
    <path d="M3 7v5l9 9 7-7-9-9H4a1 1 0 0 0-1 1Z" />
    <circle cx="7.5" cy="8.5" r="1.5" />
  </svg>
);

export const ChevronIcon = ({ className }: P): JSX.Element => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <rect width="32" height="32" rx="6" fill="rgb(var(--c-accent))" />
    <path d="M7 9h18l-9 14L7 9Z" fill="#fff" />
  </svg>
);
